import React, { useState } from "react";
import lightLogo from "../../Assets/landing/lightLogo.svg";
import { Image } from "@nextui-org/react";
import { Link } from "react-router-dom";
import qr from "../../Assets/landing/goals/qr2.jpeg";
import appStoreImage from "../../Assets/landingPage/apple-logo.png";
import googlePlayImage from "../../Assets/landingPage/google-logo.png"; 

const MainFooter = () => {
  const socialIcons = require.context("../../Assets/landing/social", true);
  const socialIconsList = socialIcons.keys().map((image) => socialIcons(image));

  const socialLinks = [
    "https://www.facebook.com/thefrondapp",
    "https://x.com/TheFrondApp",
    "https://www.instagram.com/thefrondapp",
    "https://www.linkedin.com/company/thefrondapp/?viewAsMember=true",
  ];

  return (
    <section className="font-Miranda footer pt-12 z-[9999] relative pb-6 bg-textColor">
      <div className="container xl:px-20 px-6 mx-auto">
        <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-5">
          
          {/* Column 1: Logo & Contact */}
          <div className="col flex flex-col gap-4 grow-1 sm:content-start sm:items-start items-center">
            {/* ✅ Home is Blade */}
            <a href="/">
              <Image src={lightLogo} alt="Logo" />
            </a>
            <h4 className="text-2xl font-bold bg-clip-text text-transparent bg-mainGradiant">
              Keep In Touch!
            </h4>
            <div className="social flex gap-2">
              {socialIconsList.map((icon, idx) => (
                <a target="_blank" href={socialLinks[idx]} key={idx} rel="noopener noreferrer">
                  <Image src={icon} alt="Social" />
                </a>
              ))}
            </div>
            <a
              href="mailto:info@thefrondapp.com"
              className="text-white w-fit relative after:absolute after:left-0 after:right-0 after:bottom-0 after:h-px after:bg-white"
            >
              info@thefrondapp.com
            </a>
          </div>

          {/* Column 2: Frond Links */}
          <div className="col flex flex-col gap-2 text-white text-lg sm:content-center sm:items-start items-center flex-wrap">
            <h4 className="bg-clip-text text-transparent bg-mainGradiant font-bold">Frond</h4>
            {/* ✅ Blade pages — use <a> */}
            <a href="/" className="opacity-80 hover:opacity-100">Home</a>
            <a href="/about-frond" className="opacity-80 hover:opacity-100">About frond</a>
            <a href="/contact-us" className="opacity-80 hover:opacity-100">Contact Us</a>
            <a href="/terms-of-service" className="opacity-80 hover:opacity-100">Terms Of Service</a>
            <a href="/privacy-policy" className="opacity-80 hover:opacity-100">Privacy Policy</a>
          </div>

          {/* Column 3: Tour Links */}
          <div className="col flex flex-col gap-2 text-white text-lg lg:content-center sm:items-start items-center flex-wrap">
            <h4 className="bg-clip-text text-transparent bg-mainGradiant font-bold">Tour</h4>
            {/* ✅ Blade pages — use <a> */}
            <a href="/home" className="opacity-80 hover:opacity-100">Home</a>
            <a href="/ventures" className="opacity-80 hover:opacity-100">Ventures</a>
            <a href="/events" className="opacity-80 hover:opacity-100">Events</a>
            <a href="/escape" className="opacity-80 hover:opacity-100">Escapes</a>
          </div>

          {/* Column 4: Community Links */}
          <div className="col flex flex-col gap-2 text-white text-lg sm:content-center sm:items-start items-center flex-wrap">
            <h4 className="bg-clip-text text-transparent bg-mainGradiant font-bold">Community</h4>
            {/* ✅ React pages — keep <Link> */}
            <Link to="/signup" className="opacity-80 hover:opacity-100">Register</Link>
            <Link to="/login" className="opacity-80 hover:opacity-100">Log In</Link>
            
            {/* ✅ Blade pages — use <a> */}
            <a href="/faq" className="opacity-80 hover:opacity-100">FAQs</a>
            <a href="/how-frond-works" className="opacity-80 hover:opacity-100">How frond Works</a>
            
            {/* ✅ React page — keep <Link> */}
             <a href="/blog" className="opacity-80 hover:opacity-100">Events</a>
          </div>
        </div>

        {/* Divider */}
        <div
          className="divider h-px mt-8 mb-6"
          style={{
            background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%)",
          }}
        ></div>

        {/* App Download Section */}
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-16">
            <div className="text-center md:text-left flex-1 font-Miranda">
              <h2 className="text-1xl md:text-1xl font-bold mb-4 text-white">GET THE APP</h2>
              <p className="text-white opacity-80 mb-6 leading-relaxed">
                Sign in once and stay logged in to access everything you love about frond in one place.
              </p>
              <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4">
                <a 
                  href="https://apps.apple.com/gb/app/the-frond-app/id6740921266" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-transparent border-none p-0 hover:opacity-80 transition inline-block"
                >
                  <img src={appStoreImage} alt="Download on the App Store" className="h-12 w-auto" />
                </a>
                <a 
                  href="https://play.google.com/store/apps/details?id=com.abdelhady154.TheFrondApp&pcampaignid=web_share" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-transparent border-none p-0 hover:opacity-80 transition inline-block"
                >
                  <img src={googlePlayImage} alt="GET IT ON Google Play" className="h-12 w-auto" />
                </a>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <p className="text-white mb-2 opacity-90 text-sm mt-4">Works on iOS</p>
              <div className="flex-shrink-0">
                <div className="bg-white border border-solid border-cardColor">
                  <Image src={qr} alt="QR Code" className="w-28 h-28 sm:w-32 sm:h-32 min-w-28 sm:min-w-32 object-contain" />
                </div>
              </div>
            </div>
          </div>
        </div> 

        {/* Divider */}
        <div
          className="divider h-px mt-8 mb-6"
          style={{
            background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%)",
          }}
        ></div>

        <div className="copyright text-center">
          <p className="text-white opacity-80 text-lg">
            Copyrights @ 2024 — All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MainFooter;